import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { TableColumnInterface } from '../../../../shared/components/table-custom/table-custom.interface';
import { TableColumnType } from '../../../../core/enums/table-column-type';
import { RoutingResourceEnum } from '../../../../core/enums/routing-resource-enum';
import { RoutingActionEnum } from '../../../../core/enums/routing-action-enum';
import { CustomerService } from '../../services/customer.service';
import { ResponseCustomerDto } from '../../dto/response-customer.dto';
import { Button, ButtonDirective } from 'primeng/button';
import { FilterSearchCustomComponent } from '../../../../shared/components/filter-search-custom/filter-search-custom.component';
import { LabelDescriptionCustomComponent } from '../../../../shared/components/label-description-custom/label-description-custom.component';
import { TableCustomComponent } from '../../../../shared/components/table-custom/table-custom.component';
import { ToastModule } from 'primeng/toast';
import { TranslateModule } from '@ngx-translate/core';
import { NgForOf, NgIf, UpperCasePipe } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DialogAttachmentCustomComponent } from '../../../../shared/components/dialog-attachment-custom/dialog-attachment-custom.component';
import { ExtensionsEnum } from '../../../../core/enums/extensions-enum';
import { ResponseAttachmentDto } from '../../../../core/models/response-attachment.dto';
import { StringifyFileSizePipe } from '../../../../core/pipe/stringify-pipe/stringify-file-size.pipe';

@Component({
  selector: 'app-customer',
  standalone: true,
  imports: [
    Button,
    FilterSearchCustomComponent,
    LabelDescriptionCustomComponent,
    TableCustomComponent,
    ToastModule,
    TranslateModule,
    UpperCasePipe,
    DialogModule,
    DividerModule,
    DialogAttachmentCustomComponent,
    NgIf,
    NgForOf,
    ButtonDirective,
    StringifyFileSizePipe,
  ],
  templateUrl: './search-customer.component.html',
  styleUrl: './search-customer.component.scss',
})
export class SearchCustomerComponent implements OnInit {
  constructor(
    private router: Router,
    private customerService: CustomerService,
  ) {}

  dataTable!: ResponseCustomerDto[];
  searchQuery: string = '';
  @ViewChild('table') table!: Table;
  dialogLogoVisible: boolean = false;
  customer!: ResponseCustomerDto;
  logo!: ResponseAttachmentDto[];
  logoUrl!: string;
  cols: TableColumnInterface<ResponseCustomerDto>[] = [
    {
      type: TableColumnType.ENUM,
      // fixme recuperare il nome dell'enum
      enumName: 'buyerTypeEnum',
      field: 'buyerType',
      header: 'features.customer-page.table-header.buyer-type',
    },
    {
      type: TableColumnType.STRING,
      field: 'businessName',
      header: 'features.customer-page.table-header.business-name',
    },
    {
      type: TableColumnType.STRING,
      field: 'address',
      header: 'features.customer-page.table-header.address',
    },
    {
      type: TableColumnType.STRING,
      field: 'numberOfStores',
      header: 'features.customer-page.table-header.stores',
    },
    {
      type: TableColumnType.ACTION,
      header: 'features.customer-page.table-header.logo',
      icons: [
        {
          icon: 'pi pi-image',
          action: (rowData) => this.viewLogo(rowData),
          showCondition: (rowData) => this.shouldShowLogoIcon(rowData),
        },
      ],
    },
    {
      type: TableColumnType.ACTION,
      header: '',
      icons: [
        {
          icon: 'pi pi-pencil',
          action: (rowData) => this.goToEdit(rowData._id),
        },
      ],
    },
  ];

  ngOnInit(): void {
    this.getCustomers();
  }

  getCustomers() {
    this.customerService.index().subscribe({
      next: (customers: ResponseCustomerDto[]) => {
        this.dataTable = customers;
      },
      error: (err) => {
        console.error('Error loading customers:', err);
      },
    });
  }

  goHome() {
    void this.router.navigate([RoutingResourceEnum.HOME]);
  }

  goToInsert() {
    void this.router.navigate([
      `${RoutingResourceEnum.CUSTOMERS}/${RoutingActionEnum.INSERT}`,
    ]);
  }

  goToEdit(customerId: string) {
    void this.router.navigate([
      `${RoutingResourceEnum.CUSTOMERS}/${RoutingActionEnum.EDIT}/${customerId}`,
    ]);
  }

  shouldShowLogoIcon(rowData: ResponseCustomerDto): boolean {
    return rowData.logo !== undefined && rowData.logo !== null;
  }

  viewLogo(rowData: ResponseCustomerDto) {
    console.log('viewLogo called with:', rowData);
    this.logo = [];
    this.dialogLogoVisible = true;
    this.customer = rowData;
    if (rowData.logo) {
      console.log('Logo exists:', rowData.logo);
      this.logo = [rowData.logo];
      this.customerService
        .getLogo(this.customer._id, rowData.logo.fileKey)
        .subscribe({
          next: (url: string) => {
            console.log('Logo URL received:', url);
            this.logoUrl = url;
          },
          error: (err) => {
            console.error('Error loading logo:', err);
          },
        });
    } else {
      console.warn('No logo found for customer:', rowData.businessName);
    }
  }

  downloadLogo() {
    if (this.logo.length === 1) {
      const link = document.createElement('a');
      link.href = this.logoUrl;
      link.download = this.logo[0].originalName || 'logo.png';
      link.click();
    }
  }

  protected readonly ExtensionsEnum = ExtensionsEnum;
}
